import { useTitle } from '@tm/client-form/src/hooks/useTitle'
import { ViewProps } from '../types'
import { ContactInfoView } from './ContactInfoView'
import { PlatformView } from './PlatformView'
import { useContactInfo } from './useContactInfo'
import { usePlatformFields } from './usePlatformFields'
import { useReviewFields } from './useReviewFields'

const truncate = (str: string, maxLength: number) => {
  if (str.length <= maxLength) return str
  return str.slice(0, maxLength - 3) + '...'
}

/**
 * Helper hook to get html title from current review view
 */
function useReviewTitle(props: {
  contactInfoProps: ReturnType<typeof useContactInfo>
  platformFields: ReturnType<typeof usePlatformFields>
}) {
  const getTitle = () => {
    if (props.platformFields.reviewState === 'choose platform')
      return truncate(props.platformFields.sourcesLabel || '', 40)

    if (props.contactInfoProps.textReviewProps.hasTextReview) return props.contactInfoProps.textReviewProps.label || ''
    if (props.contactInfoProps.videoReviewProps.hasVideoReview)
      return props.contactInfoProps.videoReviewProps.label || ''

    return props.contactInfoProps.title || ''
  }

  useTitle(getTitle())
}

export function ReviewLoader(props: ViewProps) {
  const { state } = props
  const { reviewFields, contactInfoLabel } = useReviewFields(state.step.fields || [])
  const platformFields = usePlatformFields(reviewFields, state.lang)

  const contactInfoProps = useContactInfo(props, reviewFields, contactInfoLabel)

  const reviewCopyEnabled = state.enableTextCopy
  const textReviewEnabled = platformFields.hasTextReview && state.enableTextReview

  useReviewTitle({
    contactInfoProps,
    platformFields,
  })

  switch (platformFields.reviewState) {
    case 'choose platform':
      return (
        <PlatformView
          {...platformFields}
          copyText={reviewCopyEnabled ? state.values.comment : undefined}
          hasTextReview={textReviewEnabled}
        />
      )

    default:
      return <ContactInfoView {...contactInfoProps} />
  }
}
